/**
 * assets/discount-banner.js
 * Gedrag van snippets/discount-banner.liquid
 *
 * Geknipt uit de inline <script> van dat bestand op 2026-08-15, 1:1.
 * Data komt uit dat bestand, gedrag staat hier. Zie ARCHITECTURE.md sectie 11.
 */

(() => {
  'use strict';

  /* Data uit Liquid, zie het JSON-eiland hierboven. Was voorheen een kale
     Liquid-interpolatie met de escape-filter midden in een JS-string. Die
     filter escapet HTML, geen JavaScript: een apostrof in een kortingscode
     brak daarmee de pagina. Nu via een JSON-eiland met de json-filter. */
  let CONFIG = {};
  try {
    const el = document.getElementById('vc-discount-config');
    if (el) CONFIG = JSON.parse(el.textContent) || {};
  } catch (e) { CONFIG = {}; }

  const DURATION = 5000;
  const CONFETTI_MS = 3500;
  const SESSION_KEY = 'vc_discount_shown';

  /* ── Kortingscode → omschrijving mapping ── */
  const DESC = {
    'WELKOM10': '10% welkomstkorting op je hele bestelling',
    'PEA6T2TX': '5% partnerkorting via KOI Center Venlo',
    'VRIENDENVAN5': '5% korting als vriend van Vijvercentrum',
  };

  /* Rad van Fortuin: sinds 04-08-2026 krijgt elke winnaar een eigen code RVF-<soort>-<6 tekens>
     (retailz-server src/api/rad.js). De oude vaste VCSPIN-codes zijn op 16-10-2026 in Shopify uitgezet. */
  const RVF = {
    VERZEND: 'Gratis verzending op je bestelling',
    '5PROC': '5% korting op je bestelling',
    '10EUR': '€10 korting vanaf €75',
    '15EUR': '€15 korting vanaf €100',
    '25EUR': '€25 korting vanaf €150',
    '15PROC': '15% korting op je bestelling',
    ONDH10: '10% korting op vijveronderhoud',
    VOER5: '€5 korting op koi- en visvoer vanaf €25',
  };
  function omschrijving(code) {
    if (DESC[code]) return DESC[code];
    const m = /^RVF-([A-Z0-9]+)-[A-Z0-9]+$/.exec(code || '');
    return m && RVF[m[1]] ? RVF[m[1]] + ' (Rad van Fortuin)' : null;
  }

  /* ══════════════════════════════════════════════════════════
     PARTNER-REF MAPPING (base64-gecodeerd tegen indexatie)
     Decoded: {"sevenum":"PEA6T2TX"}
     Voeg nieuwe partners toe door de base64 string te updaten.
     Genereer met: btoa(JSON.stringify({ref: "CODE", ...}))
     ══════════════════════════════════════════════════════════ */
  const _PM = 'eyJzZXZlbnVtIjoiUEVBNlQyVFgiLCJ2cmllbmRlbnZhbiI6IlZSSUVOREVOVkFONSJ9';

  function getPartnerMap() {
    try { return JSON.parse(atob(_PM)); } catch { return {}; }
  }

  /* ── Partner-ref detectie & stille activatie ── */
  async function activatePartnerRef() {
    const p = new URLSearchParams(location.search);
    const ref = (p.get('ref') || '').trim().toLowerCase();
    if (!ref) return null;

    const map = getPartnerMap();
    const code = map[ref];
    if (!code) return null;

    /* Al eerder getoond deze sessie?*/
    try { if (sessionStorage.getItem(SESSION_KEY) === code.toUpperCase()) return null; } catch {}

    /* Stille activatie: fetch /discount/CODE zet de Shopify discount_code cookie*/
    /* zonder pagina-reload. We navigeren niet, dus redirect wordt niet gevolgd.*/
    try {
      await fetch('/discount/' + encodeURIComponent(code) + '?redirect=/&v=banner', {
        method: 'GET',
        redirect: 'follow',
        credentials: 'same-origin',
      });
    } catch {
      /* Fallback: als fetch faalt, zet cookie handmatig (alleen voor banner-display)*/
      document.cookie = 'discount_code=' + encodeURIComponent(code) + ';path=/;max-age=1800;SameSite=Lax';
    }

    return code.toUpperCase();
  }

  /* ── Directe detectie (cookie / URL / Liquid) ── */
  function detectDirect() {
    /* 1. Shopify discount_code cookie, primaire bron na /discount/CODE*/
    const ck = document.cookie.split(';').map(c => c.trim()).find(c => c.startsWith('discount_code='));
    if (ck) {
      const val = decodeURIComponent(ck.split('=')[1]).trim();
      if (val) return val.toUpperCase();
    }

    /* 2. URL query parameter ?discount=CODE*/
    const p = new URLSearchParams(location.search);
    if (p.get('discount')) return p.get('discount').trim().toUpperCase();

    /* 3. Referrer /discount/CODE pad*/
    try {
      const m = document.referrer && new URL(document.referrer).pathname.match(/\/discount\/([^/?]+)/i);
      if (m) return decodeURIComponent(m[1]).trim().toUpperCase();
    } catch {}

    /* 4. Huidig pad /discount/CODE*/
    const pm = location.pathname.match(/\/discount\/([^/?]+)/i);
    if (pm) return decodeURIComponent(pm[1]).trim().toUpperCase();

    /* 5. Liquid fallback: cart.discount_applications*/
    const lq = CONFIG.cartDiscountCode || '';
    if (lq) return lq.toUpperCase();

    return null;
  }

  /* ── Banner ── */
  function show(code) {
    const b = document.getElementById('vc-discount-banner');
    const txt = document.getElementById('vc-discount-text');
    const det = document.getElementById('vc-discount-detail');
    const badge = document.getElementById('vc-discount-code-badge');
    const close = document.getElementById('vc-discount-close');
    if (!b) return;

    txt.textContent = 'Kortingscode geactiveerd!';
    det.textContent = omschrijving(code) || 'Je korting wordt automatisch toegepast bij het afrekenen.';

    if (badge) { badge.textContent = code; badge.classList.remove('hidden'); }

    b.style.display = '';
    requestAnimationFrame(() => requestAnimationFrame(() => {
      b.classList.remove('-translate-y-full');
      b.classList.add('translate-y-0');
    }));

    confetti();

    const t = setTimeout(hide, DURATION);
    close?.addEventListener('click', () => { clearTimeout(t); hide(); }, { once: true });
    try { sessionStorage.setItem(SESSION_KEY, code); } catch {}
  }

  function hide() {
    const b = document.getElementById('vc-discount-banner');
    if (!b) return;
    b.classList.remove('translate-y-0');
    b.classList.add('-translate-y-full');
    setTimeout(() => b.style.display = 'none', 500);
  }

  /* ── Fullscreen Confetti ── */
  function confetti() {
    const c = document.getElementById('vc-confetti-canvas');
    if (!c) return;
    const ctx = c.getContext('2d');
    if (!ctx) return;

    const W = window.innerWidth;
    const H = window.innerHeight;
    const dpr = window.devicePixelRatio || 1;
    c.width = W * dpr;
    c.height = H * dpr;
    c.style.width = W + 'px';
    c.style.height = H + 'px';
    ctx.scale(dpr, dpr);
    c.style.display = '';

    const cols = ['#0d9488','#ea580c','#ffedd5','#ffffff','#0b1e36','#fbbf24','#f59e0b','#10b981'];
    const COUNT = 0 /* was 150, disabled 27 jun 2026 */;
    const pts = Array.from({ length: COUNT }, () => ({
      x: Math.random() * W,
      y: -20 - Math.random() * H * 0.3,
      w: 5 + Math.random() * 8,
      h: 3 + Math.random() * 6,
      c: cols[Math.floor(Math.random() * cols.length)],
      vx: (Math.random() - 0.5) * 4,
      vy: 2 + Math.random() * 4,
      rot: Math.random() * 360,
      rs: (Math.random() - 0.5) * 12,
      o: 0.85 + Math.random() * 0.15,
      shape: Math.random() > 0.5 ? 'rect' : 'circle',
    }));

    const t0 = performance.now();
    (function loop(now) {
      const el = now - t0;
      if (el > CONFETTI_MS) {
        ctx.clearRect(0, 0, W, H);
        c.style.display = 'none';
        return;
      }
      const fade = el > CONFETTI_MS - 1000 ? (CONFETTI_MS - el) / 1000 : 1;
      ctx.clearRect(0, 0, W, H);
      for (const p of pts) {
        p.x += p.vx;
        p.y += p.vy;
        p.vy += 0.06;
        p.rot += p.rs;
        p.vx += (Math.random() - 0.5) * 0.1;
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot * Math.PI / 180);
        ctx.globalAlpha = p.o * fade;
        ctx.fillStyle = p.c;
        if (p.shape === 'circle') {
          ctx.beginPath();
          ctx.arc(0, 0, p.w / 2, 0, Math.PI * 2);
          ctx.fill();
        } else {
          ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        }
        ctx.restore();
      }
      requestAnimationFrame(loop);
    })(t0);
  }

  /* ══════════════════════════════════════════════════════════
     CART VALIDATIE, check of Shopify de code daadwerkelijk accepteert.
     Verlopen of ongeldige codes worden NIET getoond.
     Flow: detect code → apply via /discount/CODE → check /cart.json
     → als code in discount_applications zit → banner + confetti
     → zo niet → code is verlopen/ongeldig → skip banner + clear cookie
     ══════════════════════════════════════════════════════════ */
  async function validateDiscount(code) {
    if (!code) return false;
    try {
      /* Stap 1: Activeer de code via Shopify (zet cookie + past toe op cart)*/
      await fetch('/discount/' + encodeURIComponent(code) + '?redirect=/&v=validate', {
        method: 'GET',
        redirect: 'follow',
        credentials: 'same-origin',
      });

      /* Stap 2: Check cart.json of de code is geaccepteerd*/
      const res = await fetch('/cart.json', { credentials: 'same-origin' });
      if (!res.ok) return false;
      const cart = await res.json();

      /* Shopify zet geldige codes in cart.discount_codes[]*/
      if (cart.discount_codes && cart.discount_codes.length > 0) {
        return cart.discount_codes.some(dc =>
          dc.code.toUpperCase() === code.toUpperCase() && dc.applicable === true
        );
      }

      /* Fallback: check cart.discount_applications (oudere Shopify versies)*/
      if (cart.cart_level_discount_applications) {
        return cart.cart_level_discount_applications.some(da =>
          da.title && da.title.toUpperCase() === code.toUpperCase()
        );
      }

      return false;
    } catch {
      /* Bij netwerk error: toon banner toch (betere UX dan niets tonen)*/
      return true;
    }
  }

  function clearDiscountCookie() {
    document.cookie = 'discount_code=;path=/;max-age=0;SameSite=Lax';
  }

  /* ── INIT, twee paden ──
     A. ?ref=PARTNER → async activatie → validatie → banner
     B. /discount/CODE cookie → validatie → banner
     ══════════════════════════════════════════════════════════ */
  async function trigger(code) {
    if (!code) return;
    try { if (sessionStorage.getItem(SESSION_KEY) === code) return; } catch {}

    const valid = await validateDiscount(code);
    if (!valid) {
      /* Code is verlopen of ongeldig, niet tonen, cookie opruimen*/
      clearDiscountCookie();
      try { sessionStorage.setItem(SESSION_KEY, code); } catch {}
      return;
    }

    setTimeout(() => show(code), 400);
  }

  /* Pad A: partner-ref (async, want fetch nodig)*/
  const params = new URLSearchParams(location.search);
  if (params.get('ref')) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        activatePartnerRef().then(trigger);
      });
    } else {
      activatePartnerRef().then(trigger);
    }
  } else {
    /* Pad B: directe detectie (cookie, URL, Liquid)*/
    const code = detectDirect();
    if (!code) return;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => trigger(code));
    } else {
      trigger(code);
    }
  }
})();
